import { Injectable } from '@angular/core';
import { GlobalConstants } from '../global-constants';
import { Constants } from '../constants';
import { DataService } from '../../../core/services/data.service';
import moment from 'moment';
import { MeetingModel } from '../models/meeting-manager.model';

@Injectable({
    providedIn: 'root'
})
export class MeetingManagerService {

    private selectedDate: Date = new Date();
    private selectedTime: any = null;
    private schedulerView = '';
    private meetingManagerModel: MeetingModel = new MeetingModel();

    /**
     * Creates an instance of MeetingManagerService.
     */
    constructor(public globalConstants: GlobalConstants, // Class for Global Constants
        public constants: Constants,
        public dataService: DataService
    ) { }

    /**
     *Stores Selected Date from Meeting Manager View to be used in Add Meeting View
     *
     */
    setSelectedDate(date: any): void {
        this.selectedDate = date;
    }

    /**
     *Gets Selected Date
     *
     */
    getSelectedDate() {
        return this.selectedDate;
    }

    getMeetingTypeList() {
        const url = this.globalConstants.baseUrl + this.constants.serviceUrl.meeting.lookup;
        const param = { sortBy: 'desc' };
        return this.dataService.get(url, param);
    }

    removingSessionMeetingType() {

        if (this.globalConstants.getSessionStorage(this.constants.sessionStorageKey.agendaTemplateId)) {
            this.globalConstants.removeSessionStorage(this.constants.sessionStorageKey.agendaTemplateId);
        }
        if (this.globalConstants.getSessionStorage(this.constants.sessionStorageKey.meetingTypeId)) {
            this.globalConstants.removeSessionStorage(this.constants.sessionStorageKey.meetingTypeId);
        }

    }

    /**
     *Stores Selected Time from Meeting Manager View to be used in Add Meeting View
     *
     */
    setSelectedTime(time: any): void {
        this.selectedTime = time;
    }

    setSelectedDefaultTime() {
        const start = moment(new Date());
        const remainder = 30 - (start.minute() % 30);
        const dateTime = moment(start).add(remainder, 'minutes');
        this.selectedTime = moment(dateTime).toDate();
    }

    /**
     *Gets Selected Time
     *
     */
    getSelectedTime() {
        return this.selectedTime;
    }

    setSchedulerView(view: string) {
        this.schedulerView = view;
    }
    getSchedulerView() {
        if (this.schedulerView === '' || this.schedulerView === undefined
            || this.schedulerView === null) {
            this.schedulerView = 'list';
        }
        return this.schedulerView;
    }
    setMeetingManagerModel(value: MeetingModel) {

        this.meetingManagerModel = value;
    }
    getMeetingManagerModel(): MeetingModel {

        return this.meetingManagerModel;
    }

    clearMeetingTypeDetails() {
        if (this.globalConstants.getSessionStorage('meetingTypeId')) {
            this.globalConstants.removeSessionStorage('meetingTypeId');
        }
        if (this.globalConstants.getSessionStorage(this.constants.sessionStorageKey.meetingTypeModel)
        ) {
            this.globalConstants.removeSessionStorage(this.constants.sessionStorageKey.meetingTypeModel);
        }
    }

}
